import {md5} from 'js-md5';
const getXBdAlive = (str = '') => {
    const uk = window.uk || '';
    return md5(`${str?.substring(0, 15)}${uk}`);
};

export default getXBdAlive;